import CalendarCommunicationSettings from '@/entities/CalendarCommunicationSettings'
import FieldSettings from '@/entities/FieldSettings'

/*
  collects all main calendar settings in one place
 */
export default class CalendarSettings {
  constructor (options = {}) {
    // communication settings(actually just "availability_as" inside)
    this.communication = new CalendarCommunicationSettings(options?.communication_settings, options.type)
    // all fields settings for step B, C
    this.fields = new FieldSettings(options?.field_settings, options?.telehealth)
    // if true - appointment will be created without providerId, even if it's provider/provider_location calendar
    this.skipProviderSelection = options.skip_cal_provider_sel ? Boolean(options.skip_cal_provider_sel) : false
    // for integrated practices, includes integration name
    this.externalCalendarSource = options.external_calendar_source ? options.external_calendar_source : null
    // allow no/other insurance choise
    this.allowNoInsAnswer = Boolean(options.allow_no_ins_answer)
    // list of settings when 'call office' message need to be shown
    this.screening = Array.isArray(options?.screening_settings) ? options?.screening_settings.join(' | ') : (options.screening_settings || '')
  }
}
